import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {appHelpers} from "./_helpers";

const AuthenticatedRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        appHelpers.isAuthorised()
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/signin', state: { from: props.location } }} />
    )} />
);

export default AuthenticatedRoute;



// WEBPACK FOOTER //
// ./src/AuthenticatedRoute.js